// ConfirmModal.jsx
import React from "react";
import { Modal, Box, Typography, Button, CircularProgress, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({ open, onClose, onConfirm, question, isLoading }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={isLoading ? null : onClose}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
            <Box sx={{ width: 400, maxWidth: 'calc(100vw - 32px)', bgcolor: "white", p: 3, boxShadow: 24, borderRadius: 2 }}>
                <Alert icon={<WarningIcon />} severity="warning">
                    <strong>{t("confirmModal.warningTitle")}</strong>{" "}
                    {t("confirmModal.warningIrreversible")}
                    <br />
                    {question}
                </Alert>

                {isLoading ? (
                    <Box display="flex" flexDirection="column" alignItems="center" gap={2} mt={3}>
                        <CircularProgress size={30} />
                        <Typography variant="body2" color="textSecondary">
                            {t("confirmModal.deleting")}
                        </Typography>
                    </Box>
                ) : (
                    <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                        <Button variant="outlined" color="error" onClick={onClose} startIcon={<CloseIcon />}>
                            {t("common.cancel")}
                        </Button>
                        <Button variant="contained" color="primary" onClick={onConfirm}>
                            {t("common.yes")}
                        </Button>
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default ConfirmModal;
